import { h, Component } from 'preact'
import { language} from '../config/config'
import { API_URL } from '../main'
import { Text } from 'preact-i18n'

export default class extends Component {
    constructor(props) {
        super(props)
        
        this.print = () => {
            let {shade: {id: shade}, cable: {id: cable}, mount: {id: mount}} = this.props
            let url = `${API_URL}/print.php?lang=${language}&shade=${shade}&cable=${cable}&mount=${mount}&print`
            console.log(url)
            var iframe = $('<iframe />').css({
                pointerEvents: 'none',
                position: 'fixed',
                top: 0,
                left: 0,
                width: 1920,
                height: 1080,
                opacity: 0,
            })
            iframe.attr('src', url).on('load', function () {
                setTimeout(function(){
                    // Wenn der Print-dialog wieder weg ist
                    $(window).one('mousemove', () => iframe.remove())
                    $(iframe).one('click', () => iframe.remove())
                }, 1)
            }).appendTo('body')
        }
    }    

    render () {
        return (
            <div class="limba__controls-print limba__controls--half" ref={x => this.container = x}>
                <button onClick={this.print}><Text id="konfiguration.print" /><span class="konf-icon-Printer"></span></button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/components/Print.js